export default __webpack_public_path__ + "static/media/help-rav-qa-4.b4665237.png";